/* ════════════════════════════════════════════
   Nude Project Theme — Quick Add JavaScript
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Quick Add trigger — shows size selector
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var card = trigger.closest('[data-product-card]');
        var sizeSelector = card ? card.querySelector('[data-size-selector]') : null;

        // If product has only one variant, add directly
        if (sizeSelector && sizeSelector.children.length === 1) {
          var singleVariant = sizeSelector.querySelector('[data-variant-id]');
          if (singleVariant) {
            addToCart(singleVariant.getAttribute('data-variant-id'), trigger);
            return;
          }
        }

        // Toggle size selector
        if (sizeSelector) {
          sizeSelector.classList.toggle('is-active');
          sizeSelector.setAttribute('aria-hidden', !sizeSelector.classList.contains('is-active'));
          trigger.style.display = sizeSelector.classList.contains('is-active') ? 'none' : '';
        }
      }

      // Size item click (New Editorial Design) — add to cart
      var sizeItem = e.target.closest('.product-card__size-item:not(.is-unavailable)');
      if (sizeItem) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = sizeItem.getAttribute('data-variant-id');
        addToCart(variantId, sizeItem);
      }

      // Swatch click disabled — color swatches are display-only
      // Each color variant is listed as a separate product
      var swatch = e.target.closest('[data-swatch-color]');
      if (swatch) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    function addToCart(variantId, btnEl) {
      var originalContent = btnEl ? btnEl.innerHTML : '';
      if (btnEl) {
        btnEl.classList.add('is-loading');
        if (btnEl.classList.contains('product-card__size-item')) {
          // Keep size visible but show indicator or just fade
          btnEl.style.opacity = '0.5';
        } else {
          btnEl.textContent = '';
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (btnEl) {
          btnEl.classList.remove('is-loading');
          btnEl.style.opacity = '';
          
          if (!btnEl.classList.contains('product-card__size-item')) {
            btnEl.classList.add('is-added');
            btnEl.textContent = 'Added ✓';
          }
          
          setTimeout(function() {
            btnEl.classList.remove('is-added');
            if (!btnEl.classList.contains('product-card__size-item')) {
              btnEl.textContent = 'Quick Add';
            } else {
              btnEl.innerHTML = originalContent;
            }
          }, 1500);
        }

        document.dispatchEvent(new CustomEvent('product:added', { detail: data }));
        
        // Use global Theme utility if available to update UI
        if (window.Theme && window.Theme.Cart) {
          window.Theme.Cart.dispatchUpdate(data);
        }
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        if (btnEl) {
          btnEl.classList.remove('is-loading');
          btnEl.style.opacity = '';
          if (!btnEl.classList.contains('product-card__size-item')) {
            btnEl.textContent = 'Error';
          }
          setTimeout(function() { 
            if (!btnEl.classList.contains('product-card__size-item')) {
              btnEl.textContent = 'Quick Add'; 
            } else {
              btnEl.innerHTML = originalContent;
            }
          }, 1500);
        }
      });
    }
  });
})();
